angular
    .module('MyApp')
    .service('AlunoExtratoService', ['$resource', '$http', '$q', '$log', 'SessionData', 'Configs', 'FileSaver', function($resource, $http, $q, $log, SessionData, Configs, FileSaver) {
        var _msgErro = {msgErro: 'Error student undefined'};
    	var aluno;
    	function dadosValidosAluno(){
    		if(SessionData.aluno){
    			aluno = {codPessoa: SessionData.user.id, codAluno: encodeURIComponent(SessionData.aluno.list[SessionData.aluno.selecionado].codAluno)};
    			return true;
    		}
    		return false;
    	}
    	
        this.obterAnoDividaAluno = function() {
            let defer = $q.defer();

            if (dadosValidosAluno()) {
                $resource(Configs.getApiServer() + '/financeiro/codAluno/:codAluno/listarAnosDividaAluno', {}, {
                        cache: false,
                        query: {
                            method: 'GET'
                        }
                    })
                    .query(aluno, function(result) {
                        defer.resolve(result);
                    }, function(err) {
                        defer.reject(err);
                    });
            } else {
                defer.reject({
                    _msgErro
                });
            }

            return defer.promise;
        }

        this.obterPeriodoDividaAluno = function(ano) {
            let defer = $q.defer();

            if (dadosValidosAluno()) {
            	var params = aluno;
            	params.ano =  ano;
                $resource(Configs.getApiServer() + '/financeiro/codAluno/:codAluno/ano/:ano/listarPeriodosDividaAluno', {}, {
                        cache: false,
                        query: {
                            method: 'GET'
                        }
                    })
                    .query(params, function(result) {
                        defer.resolve(result);
                    }, function(err) {
                        defer.reject(err);
                    });
            } else {
                defer.reject({
                    _msgErro
                });
            }

            return defer.promise;
        }
        
        this.obterExtratoFinanceiro = function(dataInicial, dataFinal, ano, periodo) {
            let deferr = $q.defer();
            
            dadosValidosAluno();
            var params = aluno;
            params.ano = "";
            params.periodo = "";
            params.dataVencimentoInicial = dataInicial;
            params.dataVencimentoFinal = dataFinal;

            $resource(Configs.getApiServerCustom() + '/financeiro/obterExtratoFinanceiro', {}, {
                    'query': {
                        method: 'POST',
                        isArray: false,
                        headers: { 'Authorization': 'Basic ' + btoa('apiuser:apiuser') }
                    }
                }).query(params,
                    function(response) {
                        if (!response.status)
                            deferr.resolve(response)
                        else
                            deferr.reject();
                    },
                    function() {
                        deferr.reject();
                    });
 
            return deferr.promise;
        }
        
		this.obterExtratoFinanceiroPdf = function(dataInicial, dataFinal, ano, periodo) {
		    dadosValidosAluno();
		    var params = aluno;
            params.ano = "";
            params.periodo = "";
		    params.dataVencimentoInicial = dataInicial;
		    params.dataVencimentoFinal = dataFinal;
    
		    // Use $http directly instead of $resource for better control of binary responses
		    var req = {
		        method: 'POST',
		        url: Configs.getApiServerCustom() + '/financeiro/obterPDFExtratoFinanceiro',
		        headers: {
		            'Authorization': 'Basic ' + btoa('apiuser:apiuser'),
		            'Content-Type': 'application/json',
		            'accept-language-portal': 'pt_br'
		        },
		        data: params,
		        responseType: 'arraybuffer',
		        transformResponse: function(data) {
		            return {
		                data: data
		            };
		        }
		    };
    
		    $http(req).then(
		        function successCallback(response) {
		            // Default filename if content-disposition header is not available
		            var fileName = 'extrato-financeiro.pdf';
		            
		            // Get content type (should be application/pdf)
		            var contentType = response.headers('content-type') || 'application/pdf';
		            
		            // Try to get filename from content-disposition header if available
		            var contentDisposition = response.headers('content-disposition');
		            if (contentDisposition && contentDisposition.indexOf('filename=') !== -1) {
		                fileName = contentDisposition.substr(contentDisposition.indexOf("filename=") + 9);
		                fileName = fileName.replace(/\"/g, "");
		            }
		            
		            // Create blob and save file
		            var blob = new Blob([response.data.data], { type: contentType });
		            FileSaver.saveAs(blob, fileName);
		        },
		        function errorCallback(error) {
		            $log.debug("Erro ao realizar o download do arquivo.");
		            console.error(error);
		            
		            // Optional: Show error message to user
		            if ($ionicPopup) {
		                $ionicPopup.alert({
		                    title: 'Erro',
		                    template: 'Não foi possível gerar o extrato financeiro. Por favor, tente novamente mais tarde.'
		                });
		            }
		        }
		    );
		}      
    }]);